function parseDisplayDate(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'object' && value._seconds != null) {
    return new Date(value._seconds * 1000);
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

function formatUtcDate(value, options = { month: 'short', day: 'numeric', year: 'numeric' }) {
  const d = parseDisplayDate(value);
  if (!d) return null;
  return d.toLocaleDateString('en-US', { timeZone: 'UTC', ...options });
}

export function formatCompetitionDateRange(comp) {
  if (!comp) return '—';
  const start = comp.startDate || comp.date;
  const end = comp.endDate || (comp.eventEndMs != null ? comp.eventEndMs : start);
  const startStr = formatUtcDate(start, { month: 'short', day: 'numeric' });
  const endStr = formatUtcDate(end, { month: 'short', day: 'numeric', year: 'numeric' });
  if (startStr && endStr) {
    const startFull = formatUtcDate(start, { month: 'short', day: 'numeric', year: 'numeric' });
    if (startFull && startFull !== endStr) {
      return `${startStr} – ${endStr}`;
    }
    return endStr;
  }
  return endStr || startStr || '—';
}

export function getEligibleCompetitionSummary(eligibility) {
  if (!eligibility) {
    return {
      counting: 0,
      attended: 0,
      excluded: 0,
      primary: '0 / 3',
      label: 'Eligible competitions',
      excludedLabel: null,
      detail: null,
    };
  }

  const counting = eligibility.countingCompetitions ?? eligibility.uniqueClubsCompeted ?? 0;
  const attended = eligibility.attendedCompetitions ?? eligibility.totalCompetitions ?? 0;
  const excluded = Math.max(0, attended - counting);
  const paymentExcluded = eligibility.paymentTimingExcludedCount || 0;

  let detail = null;
  if (paymentExcluded > 0) {
    detail = `${paymentExcluded} ${paymentExcluded === 1 ? 'result' : 'results'} paid after the event ended`;
  } else if (excluded > 0) {
    detail = 'Excel, showcase, late payment, or same-club scores do not count';
  }

  return {
    counting,
    attended,
    excluded,
    primary: attended > 0 ? `${counting} / ${attended}` : `${counting} / 3`,
    label: 'Eligible competitions',
    excludedLabel: excluded > 0 ? `${excluded} don’t count` : null,
    detail,
  };
}
